import GeneratedPostCard from "./GeneratedPostCard";
import { PlaygroundResponseType, useGetSocialAttributes } from "../api/play-api";
import DownloadCSV from "./DownloadButton";
import { SetStateAction } from "react";
import Attributes from "./Attributes";

type ResultsProps = {
  result: PlaygroundResponseType,
  eventId: number,
  setEventId: React.Dispatch<SetStateAction<number>>
}

const Results = ({ result, eventId }: ResultsProps) => {
  const { postAttributes } = useGetSocialAttributes(eventId)
  return (
    <div className="w-full flex flex-col px-10">
      <div className="flex items-center justify-between w-full">
        <h2 className="text-3xl font-montserrat">Generated Posts</h2>
        <DownloadCSV jsonData={result.data} />
      </div>
      <h2 className="text-2xl font-semibold font-montserrat pt-8">{result.data.event_name}</h2>
      <p className="text-gray-600 pb-8">{result.data.event_description}</p>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-3 pb-4 gap-4">
        {result.data.posts.map(content => (
          <GeneratedPostCard
            cta={content.cta}
            text={content.text}
            hashtags={content.hashtags}
            platform={content.platform}
            key={content.text}
            date_of_posting={content.date_of_posting}
            time_of_posting={content.time_of_posting}
            image_video_recommendations={content.image_video_recommendations} />
        ))}
      </div>
      {postAttributes && <Attributes brandAttributes={postAttributes.attributes_brands} eventAttributes={postAttributes.attribute_events} />}

    </div>
  )
}

export default Results;
